import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.section == 1 ? _ctx.cancelChanges() : _ctx.section = 1))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.initialSection != 2]
            ]),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.getTitle()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              fill: "outline"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_button, {
                  slot: "start",
                  size: "normal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectRole(_ctx.customRole)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.add
                    }, null, 8, ["icon"]),
                    _cache[7] || (_cache[7] = _createTextVNode(" Add "))
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.customRole]
                ]),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: _ctx.customRole,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customRole) = $event)),
                  placeholder: "Type here if your role is not listed"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.section == 1]
        ]),
        _withDirectives(_createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              fill: "outline"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_button, {
                  slot: "start",
                  size: "normal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAddNewClass()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.add
                    }, null, 8, ["icon"]),
                    _cache[8] || (_cache[8] = _createTextVNode(" Add "))
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.customClass]
                ]),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: _ctx.customClass,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customClass) = $event)),
                  placeholder: "Type here if your class is not listed",
                  autocapitalize: "characters"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.section == 2]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rolesInClass(), (role) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: role,
                button: "",
                detail: "",
                onClick: ($event: any) => (_ctx.onSelectRole(role))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(role), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.section == 1]
        ]),
        _withDirectives(_createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClasses(), (cl) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: cl,
                button: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_checkbox, {
                    "label-placement": "end",
                    justify: "start",
                    value: cl,
                    checked: _ctx.isChecked(cl),
                    onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkboxChange($event)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cl), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "checked"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.section == 2]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              color: "success",
              expand: "block",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmChanges(_ctx.selectedRole, _ctx.selectedClasses)))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Confirm ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.section == 2 && _ctx.selectedClasses.length > 0]
    ])
  ], 64))
}